<div class="warp-white">
    <div class="grid-header">
        <div class="list-item chevron-cell pointer" [class.expanded]="isAllExpanded" (click)="toggleExpandAll()" [title]="'column.approvals.expandAll' | translate">
            <img class="chevron-icon" src="/assets/images/expand_more.svg" />
        </div>
        <div class="flex-2" translate>column.reports.name</div>
        <div class="flex-1" translate>column.questionnaireNumber</div>
        <div
      class="flex-1 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ReportSortBy.SentDate)"
      (keydown.enter)="requestSort(ReportSortBy.SentDate)"
      (keydown.space)="handleSpaceKey($event, ReportSortBy.SentDate)"
    >
      <span translate>column.reports.sentDate</span>

      <span
        *ngIf="sortBy === ReportSortBy.SentDate"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div
      class="flex-1_2 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ReportSortBy.SenderName)"
      (keydown.enter)="requestSort(ReportSortBy.SenderName)"
      (keydown.space)="handleSpaceKey($event, ReportSortBy.SenderName)"
    >
      <span translate>column.reports.senderName</span>

      <span
        *ngIf="sortBy === ReportSortBy.SenderName"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div class="flex-1_2" translate>column.reports.approvers</div>

    <div class="flex-1" translate>column.reports.formStatus</div>

    <div
      class="flex-1 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ReportSortBy.FormApprovalDate)"
      (keydown.enter)="requestSort(ReportSortBy.FormApprovalDate)"
      (keydown.space)="handleSpaceKey($event, ReportSortBy.FormApprovalDate)"
    >
      <span translate>column.reports.formApprovalDate</span>

      <span
        *ngIf="sortBy === ReportSortBy.FormApprovalDate"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>


    <div
      class="flex-1 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ReportSortBy.MlmLastExportDate)"
      (keydown.enter)="requestSort(ReportSortBy.MlmLastExportDate)"
      (keydown.space)="handleSpaceKey($event, ReportSortBy.MlmLastExportDate)"
    >
      <span translate>column.reports.mlmLastExportDate</span>

      <span
        *ngIf="sortBy === ReportSortBy.MlmLastExportDate"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div class="flex-0_8" translate>column.reports.clientCharge</div>

    <div
      class="flex-1_8 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ReportSortBy.Amount)"
      (keydown.enter)="requestSort(ReportSortBy.Amount)"
      (keydown.space)="handleSpaceKey($event, ReportSortBy.Amount)"
    >
      <span translate>column.reports.amount</span>

      <span
        *ngIf="sortBy === ReportSortBy.Amount"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>
    <div class="flex-1" translate>column.reports.mlmExportStatus</div>

    <div class="flex-half last"></div>
  </div>
</div>
